<template>
  <nav class="navbar">
    <ul class="nav__list">
      <li class="nav__item">
        <a href="https://www.facebook.com/greenpeacepl/" target="_blank" rel="noopener noreferrer"
          ><img src="@/assets/images/icons/facebook.png" alt="Facebook"
        /></a>
      </li>
      <li class="nav__item">
        <a href="https://www.instagram.com/Greenpeace_pl/" target="_blank" rel="noopener noreferrer"
          ><img src="@/assets/images/icons/instagram.png" alt="Instagram"
        /></a>
      </li>
      
      <li class="nav__item">
        <a href="https://twitter.com/Greenpeace_PL" target="_blank" rel="noopener noreferrer"
          ><img src="@/assets/images/icons/twitter.png" alt="Twitter"
        /></a>
      </li>
    </ul>

    <router-link to="/">
      <img class="nav__logo" src="@/assets/images/logo.svg" alt="Logo Greenpeace" />
    </router-link>

    <div class="font-icon">
      <div
        v-if="regularFont"
        title="Czcionka średnia"
        @click="toggleMiddleFontView()"
      >
        <img
          src="@/assets/images/icons/font_plus.svg"
          alt="Czcionka średnia ikona"
        />
      </div>

      <div v-if="middleFont" title="Czcionka duża" @click="toggleBigFontView()">
        <img src="@/assets/images/icons/font_plus.svg" alt="Czcionka duża ikona" />
      </div>

      <div
        v-if="bigFont"
        title="Czcionka domyślna"
        @click="toggleRegularFontView()"
      >
        <img
          src="@/assets/images/icons/font_minus.svg"
          alt="Czcionka domyślna ikona"
        />
      </div>
    </div>
    <div
      class=" contrast-icon"
      title="Kontrast żółto-czarny"
      @click="toggleShowContrast()"
    >
      <img
        src="@/assets/images/icons/font-contrast.svg"
        alt="Kontrast żółto-czarny ikona"
        class="mb-1"
      />
    </div>
  </nav>
</template>

<script>
export default {
  name: "Nav",
  data() {
    return {
      title: "Navigacja",
      regularFont: true,
      middleFont: false,
      bigFont: false,
    };
  },
  components: {},

  methods: {
    scrollToElement(id) {
      let positionOfElement = document.getElementById(id).offsetTop;
      if (window.innerWidth < 1200) {
        window.scroll({
          top: positionOfElement + 575,
          left: 0,
          behavior: "smooth",
        });
      } else {
        window.scroll({
          top: positionOfElement,
          left: 0,
          behavior: "smooth",
        });
      }
    },

    toggleShowContrast() {
      this.$emit("show-contrast-view");
    },
    toggleRegularFontView() {
      this.$emit("show-regular-font-view");
      this.regularFont = true;
      this.middleFont = false;
      this.bigFont = false;
    },
    toggleMiddleFontView() {
      this.$emit("show-middle-font-view");
      this.regularFont = false;
      this.middleFont = true;
      this.bigFont = false;
    },
    toggleBigFontView() {
      this.$emit("show-big-font-view");
      this.regularFont = false;
      this.middleFont = false;
      this.bigFont = true;
    },
  },
};
</script>
<style lang="scss">
.font-icon,
.contrast-icon {
  display: none;
  @media (min-width: 1200px) {
    display: block;
    color: #FF6436;
    background-color: #F0B9B6;
    position: fixed;
    right: 0;
    z-index: 999;
    width: 2.4rem;
    font-size: 1.35rem;
    padding: 0.25rem 0.35rem;
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
  }
  &:hover {
    cursor: pointer;
  }
  a {
    color: #FF6436;
  }
  a:active,
  a:visited {
    cursor: pointer;
    color: #FF6436;
  }
}
.font-icon {
  top: calc(90vh - 5rem);
}
.contrast-icon {
  top: calc(90vh - 2rem);
}
</style>
